/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import { allowedLanguageAndCountryCodes } from './services/i18n';
import ImageProvider from './components/Image/ImageProvider';
import RoutedApp from './RoutedApp';
import AutoLoginInitializer from './components/common/AutoLoginInitializer';
import LanguageRedirect from './LanguageRedirect.jsx'; // Adjust the path as needed

const createHistory = require('history').createBrowserHistory;

const langPath = `:pathLanguage(${allowedLanguageAndCountryCodes.join('|')})`;

const history = createHistory();

TagManager.initialize({ gtmId: 'GTM-N745VV5' });

const App = () => {
  useEffect(() => {
    const unlisten = history.listen((location) => {
      // Send a virtual pageview event to GTM
      TagManager.dataLayer({
        dataLayer: {
          event: 'pageview',
          pageURL: window.location.href,
          pageTitle: document.title,
          pagePath: location.pathname,
        },
      });
    });

    return () => {
      unlisten();
    };
  }, []);

  return (
    <ImageProvider>
      <Router history={history}>
        <AutoLoginInitializer />
        <Switch>
          <Route path={`/_/${langPath}`}>
            <RoutedApp />
          </Route>
          <Route path={`/${langPath}`}>
            <RoutedApp />
          </Route>
          <Route
            path="*"
            component={() => {
              const { pathname, search } = window.location;
              return <LanguageRedirect pathname={pathname} search={search} />;
            }}
          />
        </Switch>
      </Router>
    </ImageProvider>
  );
};

export default App;
